import { Environment } from '../../../environment';
import { Api } from '../axios-config';
import { jwtDecode } from 'jwt-decode';

export interface IListagemRmes {
  idfun: string;
  nome: string;
  sum: number;
}

export interface IDetalheRmes {
  idlanpro: string;
  idproducao: string;
  idpivot: string;
  descricao: string;
  idfun: string;
  datalan: string;
  periodo: string;
  pivot: string;
  vlatividade: number;
  vladicional: number;
  qtd: number;
  meta: number;
  acmeta: number;
  total: number;
}

interface JwtPayload {
  faz: string;
  loc: string;
}

type TotalCount = {
  data: IListagemRmes[];
  totalCount: number;
}

type TotalCountDia = {
  data: IDetalheRmes[];
  totalCount: number;
}

const getIdFazenda = (): string | null => {
  try {
    const accessToken = localStorage.getItem('APP_ACCESS_TOKEN');
    if (accessToken) {
      const decoded = jwtDecode<JwtPayload>(accessToken);
      return decoded.faz;
    }
  } catch (error) {
  }
  return null;
};

const getUUID = (): string | null => {
  try {
    const accessToken = localStorage.getItem('APP_ACCESS_TOKEN');
    if (accessToken) {
      const decoded = jwtDecode<JwtPayload>(accessToken);
      return decoded.loc;
    }
  } catch (error) {
  }
  return null;
};

const getAll = async (page = 1, periodo: string): Promise<TotalCount | Error> => {
  try {
    const idfazenda = getIdFazenda();
    if (!idfazenda) {
      return new Error('ID da fazenda não encontrado. Faça login novamente.');
    }

    const urlRelativa = `/lanproducao?page=${page}&limit=${Environment.LIMITE_DE_LINHAS}&periodo=${encodeURIComponent(periodo)}&idfazenda=${idfazenda}`;

    const { data, headers } = await Api.get(urlRelativa);

    if (data) {
      return {
        data,
        totalCount: Number(headers['x-total-count'] || Environment.LIMITE_DE_LINHAS),
      };
    }
 
    return new Error('Erro ao listar os registros.');
  } catch (error) {
    return new Error((error as { message: string }).message || 'Erro ao listar os registros.');
  }
};

const getById = async (page = 1, idfun: string, periodo: string, idpivot: string): Promise<TotalCountDia | Error> => {
  try {
    
    if (!idfun) {
      return new Error('ID do funcionário não fornecido.');
    }
  
    const urlRelativa = `/lanproducao/1?page=${page}&limit=31&periodo=${encodeURIComponent(periodo)}&idfun=${idfun}&idpivot=${idpivot}`;

    const { data, headers } = await Api.get(urlRelativa);
    console.log('getById', data)

    if (data && Array.isArray(data)) {
      return {
        data,
        totalCount: Number(headers['x-total-count'] || data.length),
      };
    }
 
    return {
      data: [],
      totalCount: 0,
    };
  } catch (error) {
    return new Error((error as { message: string }).message || 'Erro ao listar os registros.');
  }
};

export const RmesService = {
  getAll,
  getById,
};